export const iconFontAwesomeEditingBars = (
	<i className="fa-solid fa-bars"></i>
);
